var defaultProps = {
  intent: 'notice'
};
var getDensityProps = function getDensityProps() {
  var density = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var borderRadius = arguments.length > 1 ? arguments[1] : undefined;
  var valueFromDensity = density === 'compact' ? 'm' : 'l';
  var radius = valueFromDensity === 'm' ? '8' : '16';
  if (borderRadius !== undefined) {
    radius = borderRadius === 'm' ? '8' : '16';
  }
  return {
    p: valueFromDensity === 'm' ? '12' : '16',
    borderRadius: radius || valueFromDensity
  };
};
var getTokens = function getTokens(type, exp) {
  switch (type) {
    case 'notice':
      return {
        background: 'feedback.notice.subtle',
        text: exp !== null && exp !== void 0 && exp.isMigratingNotificationToAccessibleColor ? 'feedback.on.notice.subtle' : 'feedback.notice'
      };
    case 'positive':
      return {
        background: 'feedback.positive.subtle',
        text: exp !== null && exp !== void 0 && exp.isMigratingNotificationToAccessibleColor ? 'feedback.on.positive.subtle' : 'feedback.positive'
      };
    case 'warning':
      return {
        background: 'feedback.urgent.subtle',
        text: exp !== null && exp !== void 0 && exp.isMigratingNotificationToAccessibleColor ? 'feedback.on.urgent.subtle' : 'feedback.urgent'
      };
    case 'error':
      return {
        background: 'feedback.negative.subtle',
        text: exp !== null && exp !== void 0 && exp.isMigratingNotificationToAccessibleColor ? 'feedback.on.negative.subtle' : 'feedback.negative'
      };
    default:
      throw new Error(type);
  }
};

export { defaultProps, getDensityProps, getTokens };
//# sourceMappingURL=Notification.mappers.js.map
